import { render, staticRenderFns } from "./OrcamentoItemEdit.vue?vue&type=template&id=06e8fc92&scoped=true"
import script from "./OrcamentoItemEdit.vue?vue&type=script&lang=js"
export * from "./OrcamentoItemEdit.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoItemEdit.vue?vue&type=style&index=0&id=06e8fc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8fc92",
  null
  
)

export default component.exports